export enum Menu {
  PROFILE = 'PROFILE',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  MENU = 'MENU',
  FOOD_CATEGORY = 'FOOD_CATEGORY',
  WORK_HOURS = 'WORK_HOURS',
  EMAIL_CONFIGURATION = 'EMAIL_CONFIGURATION',
  DOCUMENTS = 'DOCUMENTS',
  ORDERS = 'ORDERS',
  PRODUCTS = 'PRODUCTS',
  USERS = 'USERS',
  REINDEX = 'REINDEX',
  KEYS = 'KEYS',
  TOKEN = 'TOKEN',
  REFRESH = 'REFRESH',
}

export enum IndexType {
  USER = 'USER',
  ORDER = 'ORDER',
  PRODUCT = 'PRODUCT',
  MEDIA = 'MEDIA',
  ADDITIONAL = 'ADDITIONAL',
}
